import { ActionBar, ChakraBox, ChakraFlex } from '@equip.health/ui';

const SMTConfigurationCardErrorFallback = () => {
  return (
    <ChakraFlex
      borderColor="neutral.line"
      borderRadius="12px"
      borderWidth="1px"
      height="200"
      margin="18px"
      padding="18px"
      width="316px"
    >
      <ChakraBox>
        <ActionBar
          id="smt-configuration-card-error-fallback"
          text="We encountered an error loading Equip Journal attributes."
          variant="critical"
        />
      </ChakraBox>
    </ChakraFlex>
  );
};

export default SMTConfigurationCardErrorFallback;
